/* eslint-disable no-unused-vars */
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert2";
import { URL } from "../../../constants/URL";
import CS from "../../../services/commonService";
import BreadCrumbs from "../../common/breadcrumbs";
import MenuItemsTable from "./menItemsTable";
import HelpQueriesTable from "./helpQueriesTable";
import GiftsTable from "./giftsTable";
import GiftsClaimedTable from "./giftsClaimedTable";
import {
	useGetRestaurantDetails,
	useDeleteRestaurant,
	useUpdateRestaurant,
	useGetOrderByRestaurant,
	useGetRestaurantSettings,
	useGetRestaurantTaxInfo,
	useGetTaxMasterRestaurant,
	useGetPartnerships,
} from "../../../queryHooks";
import { useStore } from "../../../zustand/store";
import Modal from "../../common/Modal";
import Geocode from "react-geocode";
import { CONFIG } from "../../../config/configs.js";
import ApproveRestaurant from "./approveModal";
import BusinessTypeModal from "./businessTypeModal";
import { usegetRestaurantStatus } from "../../../queryHooks/useCoupons";
import FranchiseRestaurants from "./FranchiseRestaurants";
import CustomPopover from "../../common/CustomPopover";
import Icon from "../../icons";
import PromoGiftsTable from "./PromoGiftsTable";

Geocode.setApiKey(CONFIG.GEOCODE_API_KEY);
Geocode.setLanguage("en");
Geocode.setLocationType("ROOFTOP");

//	Component starts
const RestaurantDetails = () => {
	const setLoading = useStore((state) => state.setLoading);
	const lastPageData = useStore((state) => state.lastPageData);
	//	Params
	const { slug } = useParams();
	//	Navigation
	const navigate = useNavigate();
	//	State values
	const [key, setKey] = useState(
		lastPageData?.[`tabKey${slug}`] || "restaurantMenuItems"
	);
	const [openViewImageModal, setOpenViewImageModal] = useState(false);
	const [openApproveModal, setOpenApproveModal] = useState(false);
	const [openBusinessModal, setBusinessApproval] = useState(false);
	const [geoLocation, setGeoLocation] = useState(null);
	const [restaurantConfig, setRestaurantConfig] = useState();
	const [isWorkingDaysSet, setIsWorkingDaysSet] = useState(false);
	const { data: getPartnershipsDetails } = useGetPartnerships(slug);

	const [workingHours, setWorkingHours] = useState([
		{
			day: "MONDAY",
			opens: null,
			closes: null,
		},
		{
			day: "TUESDAY",
			opens: null,
			closes: null,
		},
		{
			day: "WEDNESDAY",
			opens: null,
			closes: null,
		},
		{
			day: "THURSDAY",
			opens: null,
			closes: null,
		},
		{
			day: "FRIDAY",
			opens: null,
			closes: null,
		},
		{
			day: "SATURDAY",
			opens: null,
			closes: null,
		},
		{
			day: "SUNDAY",
			opens: null,
			closes: null,
		},
	]);

	const [tabChangeCounter, setTabChangeCounter] = useState(0);

	const { data: restaurantsSettingsData } = useGetRestaurantSettings(slug);

	useEffect(() => {
		if (restaurantsSettingsData?.status === "success") {
			setRestaurantConfig(restaurantsSettingsData?.data);
		}
	}, [restaurantsSettingsData]);

	const { data: dataGetRestaurantStripeStatus } = usegetRestaurantStatus(slug);

	/******************************************************************************************
	@Purpose    :   To get the restaurant details
	*******************************************************************************************/
	const { data: dataRestaurantDetails, refetch } =
		useGetRestaurantDetails(slug);

	//Used to make the first tab menu selected by default
	useEffect(() => {
		setKey(lastPageData?.[`tabKey${slug}`] || "restaurantMenuItems");
	}, [slug]);

	useEffect(() => {
		if (dataRestaurantDetails && dataRestaurantDetails.status === "success") {
			if (dataRestaurantDetails.data?.working_hours?.length) {
				let _workingHours = workingHours;
				for (
					let i = 0;
					i < dataRestaurantDetails.data.working_hours.length;
					i++
				) {
					const { day, opens, closes } =
						dataRestaurantDetails.data.working_hours[i];
					_workingHours = _workingHours.map((hour) => {
						if (hour.day === day) {
							return {
								day: hour.day,
								opens,
								closes,
							};
						} else return hour;
					});
				}
				setWorkingHours(_workingHours);
			}
			if (
				dataRestaurantDetails.data?.location_latitude &&
				dataRestaurantDetails.data?.location_longitude
			)
				Geocode.fromLatLng(
					dataRestaurantDetails.data?.location_latitude,
					dataRestaurantDetails.data?.location_longitude
				).then(
					(response) => {
						const address = response?.results?.[0]?.formatted_address;
						setGeoLocation(address);
					},
					(error) => {
						console.error(error);
					}
				);
		}
	}, [dataRestaurantDetails]);

	useEffect(() => {
		if (workingHours) {
			Promise.all(
				workingHours.map(async (item) => {
					if (item.opens && item.closes) setIsWorkingDaysSet(true);
				})
			);
		}
	}, [workingHours]);

	useEffect(() => {
		let val =
			dataRestaurantDetails?.data?.business_type === "FRANCHISE" &&
			!dataRestaurantDetails?.data?.parent_restaurant_id;
		if (val) setKey(lastPageData?.[`tabKey${slug}`] || "restaurantFranchise");
	}, [dataRestaurantDetails]);

	const { data: dataGetOrderByRestaurant } = useGetOrderByRestaurant(slug);

	useEffect(() => {}, [dataGetOrderByRestaurant]);

	const { data: restaurantTaxInfo } = useGetRestaurantTaxInfo(slug);

	const [masterAddressTax, setMasterAdressTax] = useState();
	const { data: taxMasterRestaurantData } = useGetTaxMasterRestaurant(slug);

	useEffect(() => {
		if (taxMasterRestaurantData?.status === "success") {
			if (taxMasterRestaurantData?.data?.taxable_restaurant) {
				const { address_state, address_country, address_postal_code } =
					taxMasterRestaurantData.data.taxable_restaurant;
				let address = `${address_state ? `${address_state},` : ""}${
					address_country ? ` ${address_country},` : ""
				}${address_postal_code ? ` ${address_postal_code}` : ""}`;
				setMasterAdressTax(address);
			}
		}
	}, [taxMasterRestaurantData]);

	const {
		mutateAsync: deleteRestaurant,
		error: errorDeleteRestaurant,
		data: dataDeleteRestaurant,
	} = useDeleteRestaurant();

	useEffect(() => {
		if (dataDeleteRestaurant) {
			setLoading(false);
			if (dataDeleteRestaurant.status === "success") {
				CS.showSuccessMessage(dataDeleteRestaurant.message);
				navigate(URL.restaurants);
			} else if (dataDeleteRestaurant.status === "fail") {
				CS.showErrorMessage(dataDeleteRestaurant.message);
			}
		}
	}, [dataDeleteRestaurant]);

	useEffect(() => {
		if (errorDeleteRestaurant) {
			setLoading(false);
			CS.showErrorMessage(errorDeleteRestaurant.response?.data?.message);
		}
	}, [errorDeleteRestaurant]);

	const {
		mutateAsync: updateRestaurant,
		error: errorUpdateRestaurant,
		data: dataUpdateRestaurant,
	} = useUpdateRestaurant();

	useEffect(() => {
		if (dataUpdateRestaurant) {
			setLoading(false);
			if (dataUpdateRestaurant.status === "success") {
				CS.showSuccessMessage(dataUpdateRestaurant.message);
				refetch();
			} else if (dataUpdateRestaurant.status === "fail") {
				CS.showErrorMessage(dataUpdateRestaurant.message);
			}
		}
	}, [dataUpdateRestaurant]);

	useEffect(() => {
		if (errorUpdateRestaurant) {
			setLoading(false);
			CS.showErrorMessage(errorUpdateRestaurant.response?.data?.message);
		}
	}, [errorUpdateRestaurant]);

	/******************************************************************************************
	@Purpose    :   Render address
	*******************************************************************************************/
	const renderAddress = (item) => {
		if (item) {
			const address = {
				address_street_1: item.address_street_1 || null,
				address_street_2: item.address_street_1 || null,
				address_city: item.address_city || null,
				address_state: item.address_state || null,
				address_country: item.address_country || null,
				address_postal_code: item.address_postal_code || null,
			};
			const result = Object.values(address).filter(Boolean).join(", ");
			return result || "-";
		}
		return "-";
	};

	const renderCuisins = (item) => {
		if (item?.length) {
			const result = item.map((a) => a.name).join(", ");
			return result || "-";
		}
		return "-";
	};

	const renderPriceRange = (item) => {
		switch (item) {
			case "1":
				return "$";
			case "2":
				return "$$";
			case "3":
				return "$$$";
			case "4":
				return "$$$$";
			default:
				return "-";
		}
	};

	const renderTime = (value) => {
		if (value.opens && value.closes) {
			return (
				moment(value.opens).format("hh:mm a") +
				" - " +
				moment(value.closes).format("hh:mm a")
			);
		}
		return "-";
	};

	const handleTabChange = (k) => {
		setKey(k);
		setTabChangeCounter((count) => count + 1);
	};

	const closeModal = () => {
		setOpenApproveModal(false);
		refetch();
	};
	const closeBussinessTypeModal = () => {
		setBusinessApproval(false);
		refetch();
	};

	const DetailsComponent = () => {
		return (
			<div className="d-flex info-content">
				<div className="mt-2">
					<ul className="info-list">
						{workingHours.map((value, key) => {
							return (
								<li key={key} className="d-flex justify-content-between mb-2">
									<h6 className="title-days">{value.day}</h6>
									<span className="sub-content">{renderTime(value)}</span>
								</li>
							);
						})}
					</ul>
				</div>
			</div>
		);
	};

	const TaxDetails = () => {
		return (
			<div className="d-flex info-content">
				<div className="mt-2">
					<ul className="info-list">
						<li className="d-flex justify-content-between mb-2">
							<h6 className="title-days">OPERATIONAL REGION</h6>
							<span className="sub-content">
								{restaurantTaxInfo?.data?.state}
							</span>
						</li>
						{restaurantTaxInfo?.data?.restaurantDocuments?.map(
							(element, key) => {
								return (
									<li key={key} className="d-flex justify-content-between mb-2">
										<h6 className="title-days">
											{element?.label?.toUpperCase()}
										</h6>
										<span className="sub-content">{element?.value}</span>
									</li>
								);
							}
						)}
					</ul>
				</div>
			</div>
		);
	};

	return (
		<>
			<div className="d-flex align-items-center justify-content-between flex-wrap mb-2">
				<BreadCrumbs
					title="Restaurants Management"
					data={[
						{ label: "Restaurants", path: URL.restaurants },
						{ label: "Restaurant Details" },
					]}
				/>
				<div className="text-right">
					{/* {dataRestaurantDetails?.data?.business_type &&
					dataRestaurantDetails?.data?.business_type == "INDIVIDUAL" ? (
						<button
							className="btn btn-danger ml-3"
							onClick={() => setBusinessApproval(true)}
						>
							<span className="bx bx-loop mr-2"></span> Change to Franchise
						</button>
					) : (
						""
					)} */}
					<Link
						to={URL.updateRestaurantSlug.replace(":slug", slug)}
						className="btn btn-primary ml-3"
					>
						<em className="bx bx-edit mr-2"></em> Edit
					</Link>
					<button
						disabled
						className="btn btn-danger ml-3"
						onClick={() =>
							swal
								.fire({
									title: "Are you sure, you want to delete this restaurant?",
									text: `You won't be able to revert this!`,
									icon: "warning",
									showCancelButton: true,
									confirmButtonColor: "#3085d6",
									cancelButtonColor: "#d33",
									confirmButtonText: "Yes, delete it!",
								})
								.then((result) => {
									if (result.isConfirmed) {
										deleteRestaurant(slug);
										setLoading(true);
									}
								})
						}
					>
						<span className="bx bx-trash-alt mr-2"></span> Delete
					</button>
				</div>
			</div>
			<div className="card-deck user-details-deck">
				<div className="card persona-info-card profile-card mb-5 col-md-8">
					<div className="space-between">
						<h4 className="d-flex title mb-4 align-items-center">
							<i className="bx bx-user mr-1" />
							Basic Information
						</h4>
						{dataRestaurantDetails?.data?.profile_image_url ? (
							<div
								title="View image"
								className="user-image cursor-pointer"
								onClick={() => setOpenViewImageModal(true)}
							>
								{CS.renderImageUrl(
									dataRestaurantDetails?.data?.profile_image_url
								)}
							</div>
						) : (
							<div className="user-image">{CS.renderImageUrl("")}</div>
						)}
					</div>
					<div className="d-flex info-content">
						<div className="personal-info">
							<ul className="info-list">
								<li>
									<h6 className="info-title">RESTAURANT NAME</h6>
									<span className="sub-content">
										{dataRestaurantDetails?.data?.name || "-"}
									</span>
								</li>
								<li>
									<h6 className="info-title">PHONE NUMBER</h6>
									<span className="sub-content">
										{dataRestaurantDetails?.data?.mobile || "-"}
										{dataRestaurantDetails?.data?.is_mobile_verified === 1 ? (
											<img
												title="Verified"
												className="verified-logo"
												src="/assets/images/check.png"
											/>
										) : (
											<img
												title="Unverified"
												className="verified-logo"
												src="/assets/images/exclamation-mark-icon.png"
											/>
										)}
									</span>
								</li>
								<li>
									<h6 className="info-title">EMAIL ADDRESS</h6>
									<span className="sub-content">
										{dataRestaurantDetails?.data?.email || "-"}
										{dataRestaurantDetails?.data?.is_email_verified === 1 ? (
											<img
												title="Verified"
												className="verified-logo"
												src="/assets/images/check.png"
											/>
										) : (
											<img
												title="Unverified"
												className="verified-logo"
												src="/assets/images/exclamation-mark-icon.png"
											/>
										)}
									</span>
								</li>
								<li>
									<h6 className="info-title">ADDRESS</h6>
									<span className="sub-content">
										{renderAddress(dataRestaurantDetails?.data)}
									</span>
								</li>
								<li>
									<h6 className="info-title">CUISINES</h6>
									<span className="sub-content">
										{renderCuisins(dataRestaurantDetails?.data?.cuisines)}
									</span>
								</li>
								<li>
									<h6 className="info-title">PRICE RANGE</h6>
									<span className="sub-content">
										{renderPriceRange(dataRestaurantDetails?.data?.price_range)}
									</span>
								</li>
								{/* {workingHours.map((value, key) => {
									return (
										<li key={key}>
											<h6 className="info-title">{value.day}</h6>
											<span className="sub-content">{renderTime(value)}</span>
										</li>
									);
								})} */}
								<li>
									<h6 className="info-title">WORKING HOURS</h6>
									<span className="sub-content">
										{isWorkingDaysSet ? (
											<CustomPopover
												title={"Working Hours"}
												DetailsComponent={<DetailsComponent />}
												IconComponent={
													<span className="title-days">
														<Icon type="show" data-tip data-for="show" />{" "}
														<span className="sub-content">View</span>
													</span>
												}
											/>
										) : (
											"-"
										)}
									</span>
								</li>
								<li>
									<h6 className="info-title">LOCATION</h6>
									<span className="sub-content">{geoLocation || "-"}</span>
								</li>
								{dataRestaurantDetails?.data?.location_latitude &&
									dataRestaurantDetails?.data?.location_longitude && (
										<a
											href="#"
											onClick={() =>
												window.open(
													`https://maps.google.com?q=
														${dataRestaurantDetails.data.location_latitude},
														${dataRestaurantDetails.data.location_longitude}`
												)
											}
										>
											Open location with Google maps
										</a>
									)}
							</ul>
						</div>
					</div>
				</div>
				<div className="card persona-info-card profile-card mb-5 col-md-4">
					<h4 className="d-flex align-items-center title mb-4">
						<i className="bx bx-package mr-1" />
						Settings & Configurations
					</h4>
					<div className="d-flex info-content">
						<div className="personal-info">
							<ul className="info-list">
								<li>
									<h6 className="info-title">FEATURED</h6>
									<span className="sub-content">
										{dataRestaurantDetails?.data?.is_featured === 1
											? "Yes"
											: "No"}
									</span>
								</li>
								<li>
									<h6 className="info-title">STRIPE STATUS</h6>
									<span className="sub-content text-capitalize">
										{dataGetRestaurantStripeStatus?.data?.stripe_account_status
											? dataGetRestaurantStripeStatus?.data?.stripe_account_status.toLowerCase()
											: "--"}
									</span>
								</li>
								{dataRestaurantDetails?.data?.admin_approval_status ===
								"APPROVED" ? (
									<li>
										<h6 className="info-title">COMMISSION RATE</h6>
										<span className="sub-content">
											{restaurantConfig?.platform_fee_percentage
												? `${restaurantConfig?.platform_fee_percentage} %`
												: "-"}
										</span>
									</li>
								) : null}
								<li>
									<h6 className="info-title">TIPS</h6>
									<span className="sub-content text-capitalize">
										{dataRestaurantDetails?.data?.restaurant_config
											?.tips_enabled === 1
											? "Enabled"
											: "Disabled"}
									</span>
								</li>
								<li>
									<h6 className="info-title">SERVICE CHARGE STATUS</h6>
									<span className="sub-content text-capitalize">
										{dataRestaurantDetails?.data?.restaurant_config
											?.service_charge_enabled === 1
											? "Enabled"
											: "Disabled"}
									</span>
								</li>
								{restaurantConfig?.service_charge_enabled ? (
									<>
										<li>
											<h6 className="info-title">SERVICE CHARGE TAX</h6>
											<span className="sub-content">
												{restaurantConfig?.service_charge_percentage
													? `${restaurantConfig?.service_charge_percentage} %`
													: "-"}
											</span>
										</li>
										<li>
											<h6 className="info-title">SERVICE CHARGE</h6>
											<span className="sub-content">
												{restaurantConfig?.service_charge_taxable
													? "True"
													: "False"}
											</span>
										</li>
									</>
								) : null}

								<li>
									<h6 className="info-title">TAX DETAILS</h6>
									<span className="sub-content">
										{restaurantTaxInfo ? (
											<CustomPopover
												title={"Tax Details"}
												DetailsComponent={<TaxDetails />}
												IconComponent={
													<span className="title-days">
														<Icon type="show" data-tip data-for="show" />{" "}
														<span className="sub-content">View</span>
													</span>
												}
											/>
										) : (
											"-"
										)}
									</span>
								</li>

								<li>
									<h6 className="info-title">TAX MASTER ADDRESS</h6>
									<span className="sub-content">
										{masterAddressTax ? masterAddressTax : "-"}
									</span>
								</li>

								<li className="d-flex align-items-center">
									<h6 className="info-title">APPROVED</h6>
									<span className="sub-content">
										{dataRestaurantDetails?.data?.admin_approval_status ===
										"APPROVED"
											? "Yes"
											: "No"}
										{dataRestaurantDetails?.data?.admin_approval_status ===
											"PENDING" && (
											<button
												className="btn btn-primary ml-2"
												// onClick={() => {
												// 	const fileData = new FormData();
												// 	fileData.append("admin_approval_status", "APPROVED");
												// 	updateRestaurant({
												// 		id: slug,
												// 		fileData,
												// 	});
												// 	setLoading(true);
												// }}
												onClick={() => setOpenApproveModal(true)}
											>
												Approve now
											</button>
										)}
									</span>
								</li>
								<li className="d-flex align-items-center">
									<h6 className="info-title">BUSINESS TYPE</h6>
									<span className="sub-content">
										{dataRestaurantDetails?.data?.business_type}
										{dataRestaurantDetails?.data?.business_type ===
											"INDIVIDUAL" && (
											<button
												className="btn btn-primary ml-2"
												onClick={() => setBusinessApproval(true)}
												style={{ minWidth: "auto" }}
											>
												Change
											</button>
										)}
									</span>
								</li>

								<li className="d-flex align-items-center">
									<h6 className="info-title">PARTNERSHIP</h6>
									<span className="sub-content">
										{getPartnershipsDetails?.data &&
										getPartnershipsDetails?.data?.total_items > 0 ? (
											<>
												<div
													className=""
													style={{ display: "flex", justifyContent: "start" }}
												>
													<div>
														{
															getPartnershipsDetails?.data?.partners[0]
																?.partner_name
														}
														{getPartnershipsDetails?.data?.total_items > 1 ? (
															<p
																style={{
																	color: "#5a8dee",
																	textDecoration: "underline",
																}}
															>
																+{getPartnershipsDetails?.data?.total_items - 1}{" "}
																more
															</p>
														) : null}
													</div>
													<div>
														<button
															// className="btn btn-primary ml-2 float-right"
															className="btn btn-primary ml-2 "
															onClick={() => {
																// sessionStorage.setItem("restaurantsId", slug);
																// URL.updateRestaurantSlug.replace(":slug", slug)
																navigate(
																	`${URL.updateIntegration.replace(
																		":slug",
																		slug
																	)}`
																);
															}}
															// style={{ minWidth: "auto" , float:"end", marginRight:"23px"}}
															style={{ minWidth: "auto" }}
														>
															Change
														</button>
													</div>
												</div>
											</>
										) : (
											<>
												<button
													// className="btn btn-primary ml-2 float-right"
													className="btn btn-primary ml-2 "
													onClick={() => {
														// sessionStorage.setItem("restaurantsId", slug);
														navigate(
															`${URL.addIntegration.replace(":slug", slug)}`
														);
													}}
													// style={{ minWidth: "78px" ,  float:"end", marginRight:"23px"}}
													style={{ minWidth: "78px" }}
												>
													Add
												</button>
											</>
										)}
									</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div className="card persona-info-card profile-card mb-5 col-md-4">
					<h4 className="d-flex align-items-center title mb-4">
						<i className="bx bx-package mr-1" />
						Order Info
					</h4>
					<div className="d-flex info-content">
						<div className="personal-info">
							<ul className="info-list">
								<li>
									<h6 className="info-title">TOTAL RECEIVED ORDERS</h6>
									<span className="sub-content">
										{dataGetOrderByRestaurant?.data?.total_orders}
									</span>
								</li>
								<li>
									<h6 className="info-title">TOTAL COMPLETED ORDERS</h6>
									<span className="sub-content">
										{dataGetOrderByRestaurant?.data?.total_completed_orders}
									</span>
								</li>
								<li>
									<h6 className="info-title">TOTAL RECEIVED PAYMENTS</h6>
									<span className="sub-content">
										$ {dataGetOrderByRestaurant?.data?.total_net_amount}
									</span>
								</li>
								<li>
									<h6 className="info-title">TOTAL COMMISSION COLLECTED</h6>
									<span className="sub-content">
										${" "}
										{
											dataGetOrderByRestaurant?.data
												?.total_platform_fee_collected
										}
									</span>
								</li>
								<li>
									<h6 className="info-title">TOTAL ESTIMATED TAX AMOUNT</h6>
									<span className="sub-content">
										$ {dataGetOrderByRestaurant?.data?.total_tax}
									</span>
								</li>
								<li>
									<h6 className="info-title">TOTAL TIPS AMOUNT</h6>
									<span className="sub-content">
										$ {dataGetOrderByRestaurant?.data?.total_tips}
									</span>
								</li>
								<li>
									<h6 className="info-title">TOTAL OPA EARNINGS</h6>
									<span className="sub-content">
										$ {dataGetOrderByRestaurant?.data?.total_platform_revenue}
									</span>
								</li>
								<li>
									<h6 className="info-title">TOTAL RESTAURANT EARNINGS</h6>
									<span className="sub-content">
										$ {dataGetOrderByRestaurant?.data?.total_restaurant_revenue}
									</span>
								</li>
								<li>
									<h6 className="info-title">TOTAL PAYOUTS PAID</h6>
									<span className="sub-content">
										$ {dataGetOrderByRestaurant?.data?.total_payouts_amount}
									</span>
								</li>
								<li>
									<h6 className="info-title">AVAILABLE PAYOUTS BALANCE</h6>
									<span className="sub-content">
										$ {dataGetOrderByRestaurant?.data?.available_payout_balance}
									</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
				{/* <div className="card persona-info-card profile-card mb-5">
					<h4 className="d-flex align-items-center title mb-4">
						<i className="bx bx-user mr-1" />
						Bank Info
					</h4>
					<div className="d-flex info-content">
						<div className="personal-info">
							<ul className="info-list">
								<li>
									<h6 className="info-title">ACCOUNT HOLDER NAME</h6>
									{bankData && (
										<React.Fragment>
											<span className="sub-content">
												{bankData?.accountObj?.firstname +
													" " +
													bankData?.accountObj?.lastname}
											</span>
										</React.Fragment>
									)}
								</li>
								<li>
									<h6 className="info-title">EMAIL ID</h6>
									{bankData && (
										<React.Fragment>
											<span className="sub-content">
												{bankData?.accountObj?.emailId}
											</span>
										</React.Fragment>
									)}
								</li>
								<li>
									<h6 className="info-title">PHONE NUMBER</h6>
									{bankData && (
										<React.Fragment>
											<span className="sub-content">
												{bankData?.accountObj?.dialCode +
													" " +
													bankData?.accountObj?.phone}
											</span>
										</React.Fragment>
									)}
								</li>
								<li>
									<h6 className="info-title">ADDRESS</h6>
									{bankData && (
										<React.Fragment>
											<span className="sub-content">
												{bankData?.accountObj?.addressLine1 +
													" " +
													bankData?.accountObj?.addressLine2 +
													", " +
													bankData?.accountObj?.city +
													", " +
													bankData?.accountObj?.stateCode?.label +
													", " +
													bankData?.accountObj?.countryCode?.label +
													", " +
													bankData?.accountObj?.postal_code}
											</span>
										</React.Fragment>
									)}
								</li>
								<li>
									<h6 className="info-title">BANK NAME</h6>
									{bankData && (
										<React.Fragment>
											<span className="sub-content">
												{bankData?.accountObj?.bankname}
											</span>
										</React.Fragment>
									)}
								</li>
								<li>
									<h6 className="info-title">ACCOUNT NUMBER</h6>
									{bankData && (
										<React.Fragment>
											<span className="sub-content">
												{bankData?.accountObj?.accountno}
											</span>
										</React.Fragment>
									)}
								</li>
								<li>
									<h6 className="info-title">ROUTING NUMBER</h6>
									{bankData && (
										<React.Fragment>
											<span className="sub-content">
												{bankData?.accountObj?.routingno}
											</span>
										</React.Fragment>
									)}
								</li>
							</ul>
						</div>
					</div>
				</div> */}
			</div>
			<div className="card notification-card tabs-block p-0">
				<Tabs
					className="pl-5 pt-3 tab-block"
					id="controlled-tab-example"
					activeKey={key}
					onSelect={handleTabChange}
				>
					{dataRestaurantDetails?.data?.business_type === "FRANCHISE" &&
						!dataRestaurantDetails?.data?.parent_restaurant_id && (
							<Tab eventKey="restaurantFranchise" title="Stores">
								<FranchiseRestaurants restaurantId={slug} />
							</Tab>
						)}
					<Tab eventKey="restaurantMenuItems" title="Menu Items">
						<MenuItemsTable
							restaurantId={slug}
							tabChangeCounter={tabChangeCounter}
						/>
					</Tab>
					<Tab eventKey="gifts" title="Gifts">
						<GiftsTable
							restaurantId={slug}
							tabChangeCounter={tabChangeCounter}
							tab={"gifts"}
						/>
					</Tab>
					<Tab eventKey="giftsCompleted" title="Completed Gifts">
						<GiftsClaimedTable
							restaurantId={slug}
							tabChangeCounter={tabChangeCounter}
							tab={"giftsCompleted"}
						/>
					</Tab>
					<Tab eventKey="promoGifts" title="Promo Gifts">
						<PromoGiftsTable
							restaurantId={slug}
							tabChangeCounter={tabChangeCounter}
							tab={"promoGifts"}
						/>
					</Tab>
					<Tab eventKey="helpQueries" title="Help Queries">
						<HelpQueriesTable
							restaurantId={slug}
							tabChangeCounter={tabChangeCounter}
						/>
					</Tab>
				</Tabs>
			</div>
			<Modal
				open={openViewImageModal}
				onCloseModal={() => setOpenViewImageModal(false)}
			>
				<div className="modal-content">
					<img src={dataRestaurantDetails?.data?.profile_image_url} />
				</div>
			</Modal>
			<Modal open={openApproveModal} onCloseModal={closeModal}>
				<ApproveRestaurant
					restaurantId={slug}
					restaurant={dataRestaurantDetails?.data}
					platformFee={restaurantConfig?.platform_fee_percentage || null}
					onCloseModal={closeModal}
				/>
			</Modal>
			<Modal open={openBusinessModal} onCloseModal={closeBussinessTypeModal}>
				<BusinessTypeModal
					restaurantId={slug}
					onCloseModal={closeBussinessTypeModal}
				/>
			</Modal>
		</>
	);
};

export default RestaurantDetails;
